import HeaderComponent from "components/card/HeaderComponent";
import React, { useEffect } from "react";
import { Table  } from 'antd';
import { handleTableChange } from "../../../../utils/index";
import EmployeeProfile from "./EmployeeProfile";
import { LucideCircleCheck, LucideCircleX, LucideClock } from "lucide-react";

const EmployeeAttendanceTable = ( props ) => {
  const { pagination, doSearch, filters } = props;

  const recordList = [
  {
    key: 1,
    employee: "Ashley Palma",
    employeeId: "EMP001",
    present: 20,
    absent: 1,
    late: 2,
    attendanceRate: "95%",
    status: "Excellent",
  },
  {
    key: 2,
    employee: "Saccharine Elupre",
    employeeId: "EMP002",
    present: 22,
    absent: 0,
    late: 1,
    attendanceRate: "100%",
    status: "Excellent",
  },
  {
    key: 3,
    employee: "Emily Rodriguez",
    employeeId: "EMP003",
    present: 21,
    absent: 1,
    late: 1,
    attendanceRate: "96%",
    status: "Excellent",
  },
  {
    key: 4,
    employee: "James Wilson",
    employeeId: "EMP004",
    present: 19,
    absent: 2,
    late: 2,
    attendanceRate: "87%",
    status: "Good",
  },
  {
    key: 5,
    employee: "Lisa Anderson",
    employeeId: "EMP005",
    present: 23,
    absent: 0,
    late: 0,
    attendanceRate: "100%",
    status: "Excellent",
  },
  {
    key: 6,
    employee: "David Martinez",
    employeeId: "EMP006",
    present: 18,
    absent: 3,
    late: 2,
    attendanceRate: "83%",
    status: "Needs Attention",
  },
  {
    key: 7,
    employee: "Jennifer Lee",
    employeeId: "EMP007",
    present: 22,
    absent: 0,
    late: 1,
    attendanceRate: "100%",
    status: "Excellent",
  },
  {
    key: 8,
    employee: "Robert Taylor",
    employeeId: "EMP008",
    present: 21,
    absent: 1,
    late: 1,
    attendanceRate: "96%",
    status: "Excellent",
  },
  {
    key: 9,
    employee: "Acee Cayanan",
    employeeId: "EMP009",
    present: 22,
    absent: 0,
    late: 0,
    attendanceRate: "100%",
    status: "Excellent",
  },
];

const columns = [
  {
    title: "Employee",
    dataIndex: "employee",
    key: "employee",
    width: "20%",
    render: (_, record) => (
      <EmployeeProfile
        employee={record.employee}
        employeeId={record.employeeId}
      />
    ),
  },
  {
    title: "Present Days",
    dataIndex: "present",
    key: "present",
    width: "15%",
    render: (value) => (
      <div className="flex items-center gap-1">
        <LucideCircleCheck size={16} className="text-green-600" />
        <span>{value}</span>
      </div>
  ),
  },
  {
    title: "Absent Days",
    dataIndex: "absent",
    key: "absent",
    width: "15%",
    render: (value) => (
      <div className="flex items-center gap-1">
        <LucideCircleX size={16} className="text-red-600" />
        <span>{value}</span>
      </div>
    ),
  },
  {
    title: "Late Arrivals",
    dataIndex: "late",
    key: "late",
    width: "15%",
    render: (value) => (
      <div className="flex items-center gap-1">
        <LucideClock size={16} className="text-orange-600" />
        <span>{value}</span>
      </div>
    ),
  },
  {
    title: "Attendance Rate",
    dataIndex: "attendanceRate",
    key: "attendanceRate",
    width: "15%",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    width: "20%",
    render: (value) => (
      <div className={`status-indicator ${value.toLowerCase().replace(/\s+/g, "-")} text-xs`}>
        {value}
      </div>
    ),
  },
];

    return (
      <HeaderComponent
        title="Employee Attendance Records"
        description="Individual attendance summary for October 2025"
      >
          <Table
                dataSource={recordList} 
                columns={columns} 
                pagination={{...pagination, showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}    
                onChange={handleTableChange(doSearch, filters)}                	
              />
      </HeaderComponent>
    );
  };
export default EmployeeAttendanceTable;